import { useState, type ReactNode } from 'react';
import { Popover } from '@localagent/ui/components/popover';
import { Tooltip } from '@localagent/ui/components/tooltip';
import { cn } from '@localagent/ui/lib/utils';

interface ChatSettingsMenuProps {
  processControl: ReactNode;
  modelPinControl: ReactNode;
  contextRagControl: ReactNode;
}

export function ChatSettingsMenu({ processControl, modelPinControl, contextRagControl }: ChatSettingsMenuProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      align="end"
      portal
      aria-label="Chat settings"
      triggerClassName={cn(
        'shrink-0 p-1.5 transition-colors',
        open ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-accent',
      )}
      contentClassName="w-72 p-1"
      trigger={
        <Tooltip label="Chat settings">
          <span data-testid="chat-settings-trigger" className="inline-flex">
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.15-.09a2 2 0 0 1-1-1.74v-.51a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </span>
        </Tooltip>
      }
    >
      <div className="flex flex-col" data-testid="chat-settings-menu">
        {processControl}
        {modelPinControl}
        {contextRagControl}
      </div>
    </Popover>
  );
}
